class Loader {
	constructor() {
		this.loadersPool = []
	}

	on(triggerEl) {
		const _on = () => {
			const loaderIndex = this._getLoaderIndexInPool(triggerEl)
			if (loaderIndex === -1) {
				const loader = document.createElement('loader-element')
				loader.attach(triggerEl)
				this.loadersPool.push(loader)
			}
		}

		if (customElements.get('loader-element')) {
			_on()
		} else {
			customElements.whenDefined('loader-element').then(_on)
		}
	}

	off(triggerEl, detachDelay = null) {
		const _off = () => {
			const loaderIndex = this._getLoaderIndexInPool(triggerEl)
			if (loaderIndex !== -1) {
				this.loadersPool[loaderIndex].detach(detachDelay)
				this.loadersPool.splice(loaderIndex, 1)
			}
		}

		if (customElements.get('loader-element')) {
			_off()
		} else {
			customElements.whenDefined('loader-element').then(_off)
		}
	}

	_getLoaderIndexInPool(triggerEl) {
		return this.loadersPool.findIndex((_loader) => _loader.triggerEl === triggerEl)
	}
}

export default Loader
